import React, { useMemo } from "react";
import { useLocale } from "../context/LocaleContext";

function formatEuro(amount) {
  return `€${Number(amount).toFixed(2)}`;
}

export function PortalBillingMetrics({
  freeWithdrawalsRemaining,
  freeWithdrawalsTotal,
  transactionQuota,
  premiumAiUsage
}) {
  const { t } = useLocale();

  const metrics = useMemo(() => {
    const items = [];

    if (freeWithdrawalsTotal > 0) {
      items.push({
        key: "free",
        label: t("billing.metrics.freeWithdrawals"),
        value: t("billing.metrics.freeWithdrawalsValue", {
          remaining: freeWithdrawalsRemaining,
          total: freeWithdrawalsTotal
        })
      });
    }

    if (transactionQuota) {
      const { transactions_used: used, transactions_included: limit } = transactionQuota;
      items.push({
        key: "included",
        label: t("billing.metrics.includedWithdrawals"),
        value: t("billing.metrics.includedWithdrawalsValue", { used, limit })
      });
    }

    if (premiumAiUsage) {
      items.push(
        {
          key: "ai-usage",
          label: t("billing.metrics.usageThisMonth"),
          value: formatEuro(premiumAiUsage.usage_charged_eur)
        },
        {
          key: "ai-requests",
          label: t("billing.metrics.requests"),
          value: String(premiumAiUsage.requests_count ?? 0)
        }
      );
    }

    return items;
  }, [freeWithdrawalsRemaining, freeWithdrawalsTotal, transactionQuota, premiumAiUsage, t]);

  if (metrics.length === 0) return null;

  return (
    <div className="portal-metrics-grid">
      {metrics.map((metric) => (
        <div key={metric.key} className="portal-metric-card">
          <p className="portal-metric-card__label">{metric.label}</p>
          <p className="portal-metric-card__value">{metric.value}</p>
        </div>
      ))}
    </div>
  );
}
